import { LoadableLazy } from '@confluence/loadable';

export const TryStandardUpflowV2ExperimentTreatmentModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-upflowV2-experiment-treatment-modal-with-error-boundary" */ './UpflowV2ExperimentErrorBoundary'
			)
		).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary,
});
